import { Box } from '@mui/material';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getReviewsBySlug, reviewsSelect } from 'redux-api/slices/reviewSlice';
import CustomInfoBlock from 'components/UI/CustomInfoBlock/CustomInfoBlock';
import { generateRel, useChangeFromMedia } from 'common/helpers';
import classes from './StudentReviews.module.scss';
import '../UI/CustomInfoBlock/Alice.scss';


const StudentReviews = (props) => {
  const dispatch = useDispatch();
  const { reviews } = useSelector(reviewsSelect);
  const { slug } = useParams();
  const { t } = useTranslation();

  const swiperOpts = useChangeFromMedia(
    { slidesPerView: 3, height: 'auto' },
    { slidesPerView: 1.18, height: 'auto', spaceBetween: 10 },
    { slidesPerView: 2.35, height: 'auto', spaceBetween: 20 },
    { slidesPerView: 1 },
    { slidesPerView: 2.12, spaceBetween: 16 },
  );
  const { technologySlug } = props;
  useEffect(() => {
    dispatch(getReviewsBySlug(technologySlug ? technologySlug : slug));

    return () => null;
  }, [ dispatch,
    slug,
    technologySlug ]);

  const isContainer = useChangeFromMedia(false, false, false, true);

  function getYoutubeVideoId(url) {
    const match = url.match(/youtube\.com\/watch\?v=([a-zA-Z0-9_-]{11})|youtu\.be\/([a-zA-Z0-9_-]{11})/);
    return match ? match[ 1 ] || match[ 2 ] : null;
  } //Функция которая берет тэг видео в дальнейшем возможно понадобиться

  if (!reviews.length) return null;
  return (
    <Box className={classes.main}>
      <CustomInfoBlock
        text={t('StudentsFeedback')}
        swiperOpts={swiperOpts}
        isContainer={isContainer}
      >
        {reviews?.map((item, i) => (
          <Box className={classes.video} key={i}>
            <iframe
              height='100%'
              width='100%'
              className={classes.iframe}
              src={`https://www.youtube.com/embed/${getYoutubeVideoId(item?.url)}`}
              title="YouTube video player"
              {...generateRel(true)}
              frameBorder="0"
              allowFullScreen
              loading='lazy'
            ></iframe>
          </Box>
        ))}
      </CustomInfoBlock>
    </Box>
  );
};

export default StudentReviews;
